export const getQueryParamString = (obj: Record<string | number, unknown>) => {
    const params = new URLSearchParams();

    Object.keys(obj).forEach(key => {
        const value: any = obj[key];

        if (![null, undefined].includes(value)) {
            if (Array.isArray(value)) {
                params.set(key, value.join(','));
            } else {
                params.set(key, value);
            }
        }
    });

    const paramStr = decodeURIComponent(params.toString());

    if (paramStr.length) {
        return '?' + paramStr;
    }

    return '';
};

export const buildHtmlSnippet = (component, args, opts) => {
    const argStr: any = [];

    if (!args?.location && opts?.placementComponents?.includes(component)) {
        argStr.push(`location= 'XX'`);
    }

    Object.keys(args).forEach(key => {
        const value: any = `"${args[key]}"`;
        key = key.replace(/_/g, '-');
        if (![null, undefined].includes(value)) {
            if (Array.isArray(value)) {
                argStr.push(`${key}=${value.join(',')}`);
            } else {
                argStr.push(`${key}=${value}`);
            }
        }
    });

    return `<${component} ${argStr.join(' ')}></${component}>`;
};
